import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

import { Class } from '../../db/classes/types';

interface ClassContextType {
  cls: Class | null;
  setClass: Dispatch<SetStateAction<Class | null>>;
}

const ClassContext = createContext<ClassContextType | undefined>(undefined);

export function useClassContext() {
  const context = useContext(ClassContext);
  if (!context) {
    throw new Error('Using useClassContext outside ClassContextProvider is not allowed.');
  }
  return context;
}

function useClassContextProviderVM() {
  const [cls, setClass] = useState<Class | null>(null);

  return useMemo(
    () => ({
      cls,
      setClass,
    }),
    [cls]
  );
}

export interface ClassContextProviderProps {
  children: ReactNode;
}

export function ClassContextProvider({ children }: ClassContextProviderProps) {
  const providerValue = useClassContextProviderVM();
  return <ClassContext.Provider value={providerValue}>{children}</ClassContext.Provider>;
}
